import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ApiStatus } from '../../types/api/status'
import { TypeAttribute, typeAttributesType } from '../../types/slices/typeAttributesType'

const initialState: typeAttributesType =
{
    status: ApiStatus.FETCHED,
    typeAttributes: [],
    typeAttributeSelected: {} as TypeAttribute,
    errorMessage: undefined,
    action: ''
}

const typeAttributeSlice = createSlice({
    name: 'typeAttributeSlice',
    initialState,
    reducers: {
        onFetchTypeAttribute (state, { payload }: { payload: TypeAttribute[]}) {
        state.status = ApiStatus.FETCHED
        state.typeAttributes = payload
        state.errorMessage = undefined
        },
        onSetSelectedtypeAttribute (state, { payload }: { payload: TypeAttribute }) {
        state.typeAttributeSelected = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
        state.status = payload
        },
        setAction (state, { payload }: { payload: string }) {
        state.action = payload
        },
    }
})

export const selectTypeAttributeState = (state: RootState) => state.typeAttributeSlice
export default typeAttributeSlice.reducer
export const {
    onFetchTypeAttribute,
    onSetSelectedtypeAttribute,
    changeStatus,
    setAction,
} = typeAttributeSlice.actions
